import {
  DeleteEvaluationFormDocument,
  DeleteEvaluationFormMutation,
  EvaluationFormListItemFragment,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useDeleteEvaluationForm = (evaluationForm: EvaluationFormListItemFragment) => {
  const [deleteEvaluationForm, { loading }] = useMutation(DeleteEvaluationFormDocument, {
    extractorFn: (data: DeleteEvaluationFormMutation) => data.atsMutations.deleteAtsEvaluationForm,
  })

  return {
    loading,
    deleteEvaluationForm() {
      return deleteEvaluationForm({
        variables: { id: evaluationForm.id },
        update(cache, mutationResult) {
          if (mutationResult.data?.atsMutations.deleteAtsEvaluationForm.evaluationForm) {
            cache.evict({ id: cache.identify(evaluationForm) })
          }
        },
      })
    },
  }
}
